var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAlertManagerStandardEnterprise = function SvgAlertManagerStandardEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#fabc3c",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.01 28.76a1.99 1.99 0 103.98 0zM20 13.75a5.002 5.002 0 015 5v7H15v-7a5.002 5.002 0 015-5zm0-4.5a1.498 1.498 0 00-1.5 1.5v1.17a6.993 6.993 0 00-5.5 6.83v6l-2 2v1h18v-1l-2-2v-6a6.993 6.993 0 00-5.5-6.83v-1.17a1.498 1.498 0 00-1.5-1.5zm1 6.5h-2v3h-3v2h3v3h2v-3h3v-2h-3z",
    fill: "#fabc3c"
  })));
};
export default SvgAlertManagerStandardEnterprise;